export default {
  qHyperCubeDef: {
    qDimensions: [
      {
        qDef: { qFieldDefs: ['player_name'], qFieldLabels: ['Player'], qSortCriterias: [{ qSortByState: 1, qSortByExpression: -1, qExpression: { qv: 'count_tournaments' } }] },
        qAttributeExpressions: [
          {
            qExpression: '=Date(birth_date)',
          },
          {
            qExpression: '=Count(match_id)',
          },
          {
            qExpression: '=Count(distinct goal_id)',
          },
          {
            qExpression: '=(Count(distinct goal_id) / Count(match_id))',
            qNumFormat: {
              qType: 'F',
              qnDec: 2,
              qUseThou: 0,
              qFmt: '#,##0.00',
              qDec: '.',
              qThou: ',',
            },
          },
          {
            qExpression: '=Sum(red_card)',
          },
          {
            qExpression: '=Sum(yellow_card)',
          },
          {
            qExpression: '=Sum(second_yellow_card)',
          },
          {
            qExpression: '=Only(count_tournaments)',
          },
          {
            qExpression: '=Only(team_name)',
          },
          {
            qExpression: '=Only(team_code)',
          },
        ],
        qNullSuppression: true,
      },
    ],
    // qMeasures: [
    //   {
    //     qDef: { qDef: 'Date(birth_date)', autoSort: false, qLabel: 'Birth Date' },
    //     qSortBy: { qSortByNumeric: -1 },
    //   },
    //   {
    //     qDef: { qDef: 'Count(match_id)', autoSort: false, qLabel: 'Games Played' },
    //     // If(count({<starter={'1'}> + <substitute={'1'}>} match_id), If((count({<starter={'1'}>} match_id) > 0) or (count(substitute={1} match_id) > 0), count({<starter={'1'}> + <substitute={'1'}>} match_id), null()), null())
    //     qSortBy: { qSortByNumeric: -1 },
    //   },
    //   {
    //     qDef: { qDef: 'Count(distinct goal_id)', autoSort: false, qLabel: 'Goals' },
    //     //  =If(count({<starter={'1'}> + <substitute={'1'}>} match_id), If(count({<starter={'1'}>} match_id) > 0, Count(distinct goal_id), null()), null())
    //     qSortBy: { qSortByNumeric: -1 },
    //   },
    //   {
    //     qDef: {
    //       qDef: ' Count(distinct goal_id) / Count(match_id)',
    //       autoSort: false,
    //       qLabel: 'Goals per Game',
    //       qNumFormat: {
    //         qType: 'F',
    //         qnDec: 2,
    //         qUseThou: 0,
    //         qFmt: '#,##0.00',
    //         qDec: '.',
    //         qThou: ',',
    //       },
    //     },
    //     //= If(count({<starter={'1'}> + <substitute={'1'}>} match_id), If(count({<starter={'1'}>} match_id) > 0, Count(distinct goal_id) / count({<starter={'1'}>} match_id), null()), null())
    //     qSortBy: { qSortByNumeric: -1 },
    //   },
    //   {
    //     qDef: { qDef: 'Sum(red_card)', autoSort: false, qLabel: 'Red Cards' },
    //     // =If(count({<starter={'1'}> + <substitute={'1'}>} match_id), If(count({<starter={'1'}>} match_id) > 0, Sum(red_card), null()), null())
    //     qSortBy: { qSortByNumeric: -1 },
    //   },
    //   {
    //     qDef: { qDef: 'sum(yellow_card)', autoSort: false, qLabel: 'Yellow Cards' },
    //     // =If(count({<starter={'1'}> + <substitute={'1'}>} match_id), If(count({<starter={'1'}>} match_id) > 0, sum(yellow_card), null()), null())
    //     qSortBy: { qSortByNumeric: -1 },
    //   },
    //   {
    //     qDef: { qDef: 'sum(second_yellow_card)', autoSort: false, qLabel: 'Second Yellow Cards' },
    //     // =If(count({<starter={'1'}> + <substitute={'1'}>} match_id), If(count({<starter={'1'}>} match_id) > 0, sum(second_yellow_card), null()), null())
    //     qSortBy: { qSortByNumeric: -1 },
    //   },
    // ],
    qInitialDataFetch: [{
      qWidth: 1,
      qHeight: 10000,
    }],
  },
};
